module.exports = __webpack_public_path__ + "img/company.90086f6f.jpg";